export const UPDATE_ORDER_SCHEDULED_PAYMENT_DATE = `
  mutation UpdateOrderScheduledPaymentDate(
    $input: UpdateOrderScheduledPaymentDateInput!
  ) {
    updateOrderScheduledPaymentDate(input: $input) {
      orderId
      orderNumber
      scheduledPaymentDate
      updatedAt
    }
  }
`

export const CREATE_ORDER_PDF_DOWNLOAD_URL = `
  mutation CreateOrderPdfDownloadUrl($orderId: ID!, $disposition: String) {
    createOrderPdfDownloadUrl(
      orderId: $orderId
      disposition: $disposition
    ) {
      pdfStatus
      lastPdfError
      errorCode
      url
      expiresAt
    }
  }
`
